const errors = {
  docs: []
}

export default {
  list: [],
  initialErrors: { ...errors },
  errors: { ...errors }
}



// WEBPACK FOOTER //
// ./src/features/payer_invoice_upload/store/state.js